export default __webpack_public_path__ + "blank-file.png";